/*
  TODO:
    1. Add other requests (DELETE, UPDATE) if needed
    1. Add other options for requests (HEADERS including tokens, etc...) if needed

*/

const fetchOptions = function getFetchOptions(type, payload) {
  const formData = new FormData();

  switch (type) {
    case 'getWithCredentials':
      return {
        method: 'GET',
        credentials: 'same-origin',
      };
    case 'post':
      return {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'same-origin',
      };
    case 'postForm':
      Object.keys(payload).forEach(key => formData.append(key, payload[key]));
      return {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      };
    default:
      return {
        method: 'GET',
        credentials: 'same-origin',
      };
  }
};

export default fetchOptions;
